const OVERRIDES_WATCH_MS = 5000;

// Roots of the content we present through usePopup. Identifying our modal by
// the content it hosts is the same approach the SWJ styles already take
// (`#core-modal-presenter-content:has(.jackpot-animations-container)`).
const POPUP_CONTENT =
  '.popup__container, .jackpot-animations-container, .in-game-merch-overlay--blocking, .in-game-merch-overlay--toast';

export const applyCoreModalsOverrides = () => {
  // Workaround to remove header and reset content width
  // as CoreModalPresenter does not support this use case yet
  // and we want to avoid custom modals for now.
  const overrides = () => {
    // The presenter puts these same ids on every modal it stacks and gives only
    // the outer dialog a unique one, so a document-wide getElementById lands on
    // whichever modal is first in the DOM — the wrong one as soon as two are
    // open. Resolve them per modal instead, starting from our own content, so
    // stacked modals stay correct and modals we did not present (e.g. the UM
    // deposit cashier) are left alone.
    document.querySelectorAll(POPUP_CONTENT).forEach((popupContent) => {
      const modal = popupContent.closest<HTMLElement>('[role="dialog"]');

      if (!modal) {
        return;
      }

      const header = modal.querySelector<HTMLElement>(
        '#core-modal-presenter-header-wrapper',
      );
      const content = modal.querySelector<HTMLElement>(
        '#core-modal-presenter-content',
      );
      const bodyContent = modal.querySelector<HTMLElement>(
        '#core-modal-presenter-body-content',
      );

      if (bodyContent) {
        bodyContent.style.width = '100%';
        bodyContent.style.backgroundColor = 'transparent';
        bodyContent.style.display = 'flex';
        bodyContent.style.justifyContent = 'center';
        bodyContent.style.alignItems = 'center';
      }

      if (content) {
        content.style.width = 'unset';
      }

      if (header) {
        header.style.display = 'none';
      }

      // The toast variant floats over the game without blocking it: it must not
      // inherit content's transform-based centering (our own position: fixed
      // wrapper would measure against that transformed box instead of the real
      // viewport) or the dialog's dark backdrop/click-capture.
      if (popupContent.matches('.in-game-merch-overlay--toast')) {
        if (content) {
          content.style.top = '0';
          content.style.left = '0';
          content.style.transform = 'none';
        }
        modal.style.backgroundColor = 'transparent';
        modal.style.pointerEvents = 'none';
      }
    });
  };

  // Apply immediately in case the modal DOM is already rendered, then keep
  // re-applying as the modal DOM changes for a short window. A step transition
  // (e.g. geolocation LOADING -> SUCCESS) dismisses one modal and mounts the
  // next, so the incoming modal is not in the DOM yet when this runs.
  overrides();

  const observer = new MutationObserver(() => overrides());

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => observer.disconnect(), OVERRIDES_WATCH_MS);
};
